module.exports = __webpack_public_path__ + "img/8a79a1a.jpg";